// import Home from '@/components/index'

export default [
    {
        name: 'youtube',
        path: '/youtube',
        beforeEnter() {                    
            window.open("https://www.youtube.com/channel/UCWsvKRwdW2yG4_Onw7vdPbg?view_as=subscriber",'_blank');
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/development/development.js